import Canvas from "./Canvas";
import { LayoutsProvider } from "./LayoutsProvider";
import { LayoutStatusProvider } from './LayoutStatusContext';
import Sidebar from "./Sidebar";

export default function Main() {
    return (
        <div className="flex h-full bg-[#FAFDFF] overflow-hidden">
            <Sidebar />
            <LayoutsProvider>
                <LayoutStatusProvider>
                    <Canvas />
                </LayoutStatusProvider>
            </LayoutsProvider>
        </div>
    )
}